export const apiConst = {
  encdef: 'vote for NDM',
  bucdef: 'prod-ewa-corporate-policy-docs',
  bucpol: 'prod-ewa-member-uploaded-policies',
  conpho: 'prod-ewa-consumer-photographs',
  bandef: 'prod-ewa-banner-bucket',
  clidef: 'EWA',
  cladoc: 'prod-ewa-claim-docs',
  idtdoc: 'prod-ewa-tempidcard',
};
